import { render, staticRenderFns } from "./AllClassify.vue?vue&type=template&id=af673f08&scoped=true&"
import script from "./AllClassify.vue?vue&type=script&lang=js&"
export * from "./AllClassify.vue?vue&type=script&lang=js&"
import style0 from "./AllClassify.vue?vue&type=style&index=0&id=af673f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af673f08",
  null
  
)

export default component.exports